import { render, staticRenderFns } from "./CursoNuevo.vue?vue&type=template&id=783a2f89&"
import script from "./CursoNuevo.vue?vue&type=script&lang=js&"
export * from "./CursoNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports